/**
 * @generated SignedSource<<73c12d33c65d8385286246a2decb8a5e>>
 * @relayHash bf70531d03392c3e26645e9b0157e94e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c121d529b1a3e379a0c9538e95aa54b96761a6bbc7f64da2ea612987667af130

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type editHomepageQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  layoutAri: string;
};
export type editHomepageQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "QueryError";
      readonly " $fragmentSpreads": FragmentRefs<"globalBrandingSettingsPanelFragment">;
    } | null | undefined;
    readonly mediaConfig: {
      readonly " $fragmentSpreads": FragmentRefs<"globalBrandingSettingsPanelMediaConfigFragment">;
    };
  } | null | undefined;
  readonly helpLayout: {
    readonly elementTypes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"elementsCatalogueFragment">;
    }> | null | undefined;
    readonly layout: {
      readonly " $fragmentSpreads": FragmentRefs<"layoutBuilderFragment" | "useLayoutServiceFragment">;
    };
    readonly mediaConfig: {
      readonly asapIssuer: string | null | undefined;
      readonly mediaCollectionName: string | null | undefined;
      readonly mediaToken: string | null | undefined;
      readonly mediaUrl: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type editHomepageQuery = {
  response: editHomepageQuery$data;
  variables: editHomepageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "layoutAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "layoutAri"
  }
],
v7 = {
  "alias": "layoutId",
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "concreteType": "HelpLayoutSubsectionConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "span"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "adf"
},
v10 = {
  "kind": "ScalarField",
  "name": "horizontalAlignment"
},
v11 = {
  "kind": "ScalarField",
  "name": "verticalAlignment"
},
v12 = {
  "concreteType": "HelpLayoutAlignmentSettings",
  "kind": "LinkedField",
  "name": "alignment",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "fileId"
},
v14 = {
  "kind": "ScalarField",
  "name": "url"
},
v15 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "backgroundType"
},
v17 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v18 = {
  "kind": "ScalarField",
  "name": "foregroundColor"
},
v19 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v20 = {
  "kind": "ScalarField",
  "name": "titleColor"
},
v21 = [
  (v12/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useLayoutServiceVisualConfigData",
      "selections": (v21/*: any*/),
      "argumentDefinitions": ([]/*: any*/)
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "useGlobalSettings"
},
v24 = [
  (v22/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "expandButtonTextColor"
},
v26 = {
  "kind": "ScalarField",
  "name": "forgeElementPage"
},
v27 = {
  "kind": "ScalarField",
  "name": "forgeElementType"
},
v28 = {
  "kind": "ScalarField",
  "name": "connectElementPage"
},
v29 = {
  "kind": "ScalarField",
  "name": "connectElementType"
},
v30 = {
  "kind": "ScalarField",
  "name": "__id"
},
v31 = {
  "kind": "ClientExtension",
  "selections": [
    (v30/*: any*/)
  ]
},
v32 = [
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterAri"
  }
],
v33 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v34 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v35 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v36 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v37 = [
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/)
],
v38 = {
  "args": (v32/*: any*/),
  "concreteType": "HelpLayoutMediaConfig",
  "kind": "LinkedField",
  "name": "mediaConfig",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = [
  (v14/*: any*/),
  (v13/*: any*/)
],
v40 = {
  "kind": "ScalarField",
  "name": "id"
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v42 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v43 = {
  "kind": "ScalarField",
  "name": "key"
},
v44 = {
  "kind": "ScalarField",
  "name": "name"
},
v45 = {
  "kind": "ScalarField",
  "name": "logo"
},
v46 = {
  "kind": "ScalarField",
  "name": "portalId"
},
v47 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ]
},
v48 = {
  "concreteType": "HelpLayoutAtomicElementType",
  "kind": "LinkedField",
  "name": "elementType",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/)
  ]
},
v49 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isHelpLayoutVisualEntity"
},
v50 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": (v39/*: any*/)
},
v51 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": (v21/*: any*/)
},
v52 = {
  "kind": "ScalarField",
  "name": "isInstalled"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editHomepageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "globalBrandingSettingsPanelFragment"
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "QueryError"
              }
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": (v4/*: any*/),
              "concreteType": "HelpCenterMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "globalBrandingSettingsPanelMediaConfigFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "helpCenter.mediaConfig"
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v6/*: any*/),
              "kind": "LinkedField",
              "name": "layout",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "layoutBuilderFragment"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "useLayoutServiceFragment",
                      "selections": [
                        (v7/*: any*/),
                        {
                          "concreteType": "HelpLayoutSectionConnection",
                          "kind": "LinkedField",
                          "name": "sections",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "HelpLayoutSectionEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "concreteType": "HelpLayoutSection",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "HelpLayoutSubsection",
                                      "kind": "LinkedField",
                                      "name": "subsections",
                                      "plural": true,
                                      "selections": [
                                        (v8/*: any*/),
                                        {
                                          "kind": "LinkedField",
                                          "name": "elements",
                                          "plural": true,
                                          "selections": [
                                            (v5/*: any*/),
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceEditorElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    (v9/*: any*/),
                                                    (v22/*: any*/)
                                                  ],
                                                  "type": "HelpLayoutEditorElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceHeroElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    (v23/*: any*/),
                                                    (v22/*: any*/)
                                                  ],
                                                  "type": "HelpLayoutHeroElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceAnnouncementElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v24/*: any*/),
                                                  "type": "HelpLayoutPortalsListElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceTopicsElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v24/*: any*/),
                                                  "type": "HelpLayoutTopicsListElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceListOfPortalsElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    (v25/*: any*/),
                                                    (v22/*: any*/)
                                                  ],
                                                  "type": "HelpLayoutPortalsListElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v24/*: any*/),
                                                  "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceForgeElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    (v26/*: any*/),
                                                    (v27/*: any*/),
                                                    (v22/*: any*/)
                                                  ],
                                                  "type": "HelpLayoutForgeElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceConnectElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    (v28/*: any*/),
                                                    (v29/*: any*/),
                                                    (v22/*: any*/)
                                                  ],
                                                  "type": "HelpLayoutConnectElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceBreadcrumbElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v24/*: any*/),
                                                  "type": "HelpLayoutBreadcrumbElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            },
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "useLayoutServiceKnowledgeCardsElementData",
                                              "selections": [
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": (v24/*: any*/),
                                                  "type": "HelpLayoutKnowledgeCardsElement"
                                                }
                                              ],
                                              "argumentDefinitions": []
                                            }
                                          ]
                                        },
                                        (v22/*: any*/)
                                      ]
                                    },
                                    (v22/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        (v31/*: any*/)
                      ],
                      "argumentDefinitions": []
                    }
                  ],
                  "type": "HelpLayout"
                }
              ]
            },
            "action": "THROW",
            "path": "helpLayout.layout"
          },
          (v38/*: any*/),
          {
            "kind": "LinkedField",
            "name": "elementTypes",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "elementsCatalogueFragment"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "editHomepageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": (v39/*: any*/)
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              (v41/*: any*/)
            ]
          },
          {
            "args": (v4/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": (v37/*: any*/)
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "layout",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v40/*: any*/),
                  {
                    "concreteType": "HelpLayoutSectionConnection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpLayoutSectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "HelpLayoutSection",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpLayoutSubsection",
                                "kind": "LinkedField",
                                "name": "subsections",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHelpLayoutElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "HelpLayoutAtomicElementType",
                                            "kind": "LinkedField",
                                            "name": "elementType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "args": (v32/*: any*/),
                                                "concreteType": "HelpLayoutMediaConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaConfig",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  (v34/*: any*/),
                                                  (v33/*: any*/),
                                                  (v36/*: any*/)
                                                ]
                                              },
                                              (v42/*: any*/),
                                              (v43/*: any*/)
                                            ]
                                          },
                                          (v40/*: any*/),
                                          {
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "HelpLayoutAlignmentSettings",
                                                "kind": "LinkedField",
                                                "name": "alignment",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*: any*/),
                                                  (v11/*: any*/),
                                                  (v31/*: any*/)
                                                ]
                                              },
                                              (v15/*: any*/),
                                              (v16/*: any*/),
                                              (v17/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          },
                                          (v31/*: any*/)
                                        ],
                                        "type": "HelpLayoutEditorElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutPortalCard",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": true,
                                            "selections": [
                                              (v44/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "description"
                                              },
                                              (v45/*: any*/),
                                              (v46/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "isFeatured"
                                              },
                                              (v5/*: any*/)
                                            ]
                                          },
                                          (v25/*: any*/),
                                          (v47/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v49/*: any*/)
                                        ],
                                        "type": "HelpLayoutPortalsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutRequestForm",
                                            "kind": "LinkedField",
                                            "name": "suggestedRequestTypes",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "descriptionHtml"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "portalName"
                                              },
                                              (v40/*: any*/),
                                              (v46/*: any*/),
                                              (v44/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v5/*: any*/)
                                            ]
                                          },
                                          (v47/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v49/*: any*/)
                                        ],
                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "header"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "message"
                                          },
                                          (v48/*: any*/)
                                        ],
                                        "type": "HelpLayoutAnnouncementElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicId"
                                              },
                                              (v19/*: any*/),
                                              {
                                                "concreteType": "HelpLayoutTopicItem",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                  },
                                                  (v45/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "displayLink"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "entityKey"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "helpObjectType"
                                                  },
                                                  (v31/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicName"
                                              }
                                            ]
                                          },
                                          (v47/*: any*/),
                                          (v40/*: any*/),
                                          (v48/*: any*/),
                                          (v49/*: any*/)
                                        ],
                                        "type": "HelpLayoutTopicsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v23/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "homePageTitle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "userLanguageTag"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "showCSMAISearchTrigger"
                                          },
                                          {
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v17/*: any*/),
                                              (v16/*: any*/),
                                              (v50/*: any*/),
                                              (v12/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          },
                                          (v40/*: any*/),
                                          (v48/*: any*/)
                                        ],
                                        "type": "HelpLayoutHeroElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutBreadcrumb",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "relativeUrl"
                                              },
                                              (v44/*: any*/)
                                            ]
                                          },
                                          (v48/*: any*/),
                                          (v51/*: any*/)
                                        ],
                                        "type": "HelpLayoutBreadcrumbElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v27/*: any*/),
                                          (v26/*: any*/),
                                          (v48/*: any*/),
                                          (v52/*: any*/),
                                          (v51/*: any*/)
                                        ],
                                        "type": "HelpLayoutForgeElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v28/*: any*/),
                                          (v29/*: any*/),
                                          (v48/*: any*/),
                                          (v52/*: any*/),
                                          (v51/*: any*/)
                                        ],
                                        "type": "HelpLayoutConnectElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "statusCode"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "QueryError"
                                      },
                                      (v31/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutAtomicElementType",
                                            "kind": "LinkedField",
                                            "name": "elementType",
                                            "plural": false,
                                            "selections": [
                                              (v43/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "HelpLayoutNoContentElement"
                                      },
                                      (v41/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v51/*: any*/)
                                        ],
                                        "type": "HelpLayoutKnowledgeCardsElement"
                                      }
                                    ]
                                  },
                                  (v40/*: any*/),
                                  (v51/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutVisualConfig",
                                        "kind": "LinkedField",
                                        "name": "visualConfig",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutAlignmentSettings",
                                            "kind": "LinkedField",
                                            "name": "alignment",
                                            "plural": false,
                                            "selections": [
                                              (v31/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "HelpLayoutVisualEntity",
                                    "abstractKey": "__isHelpLayoutVisualEntity"
                                  },
                                  (v31/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "HelpLayoutVisualConfig",
                                "kind": "LinkedField",
                                "name": "visualConfig",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v16/*: any*/),
                                  (v50/*: any*/),
                                  (v19/*: any*/),
                                  (v12/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/)
                                ]
                              },
                              (v40/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": "dataId",
                                    "kind": "ScalarField",
                                    "name": "__id"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  (v31/*: any*/)
                ],
                "type": "HelpLayout"
              },
              (v41/*: any*/)
            ]
          },
          (v38/*: any*/),
          {
            "kind": "LinkedField",
            "name": "elementTypes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpLayoutElementType"
              },
              (v42/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "atomicKey",
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "args": (v32/*: any*/),
                    "concreteType": "HelpLayoutMediaConfig",
                    "kind": "LinkedField",
                    "name": "mediaConfig",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v35/*: any*/),
                      (v34/*: any*/),
                      (v33/*: any*/),
                      (v36/*: any*/)
                    ]
                  }
                ],
                "type": "HelpLayoutAtomicElementType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "compositeKey",
                    "kind": "ScalarField",
                    "name": "key"
                  }
                ],
                "type": "HelpLayoutCompositeElementType"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c121d529b1a3e379a0c9538e95aa54b96761a6bbc7f64da2ea612987667af130",
    "metadata": {},
    "name": "editHomepageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "76a98be18ada7d4f36ce6c2f7f9559d6";

export default node;
